<template>
    <section class="m-logo-blk1">
        <a
            v-for="item in logo1Arr"
            :key="item.id"
            :class="[item.type=='little'?'m-logo2':'m-logo1']"
            :href="[item.href?item.href:'javascript:;']"
        >
            <!-- target="_blank" -->
            <img :src="item.pic" :alt="item.des" />
        </a>
    </section>
</template>

<script>
export default {
    name: "logo1",
    props: {
        logo1Arr: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            msg: "logo1"
        };
    }
};
</script>
